<template>
    <div class="footer-info">
        <p class="text-policy">
            By continuing you agree to the<br />Tinybeans <a href="/terms/" target="_blank">Terms</a> & <a href="/privacy/" target="_blank">Privacy policy</a>
        </p>
        <p v-if="isSignup" class="text-login">Already have an account? <router-link to="login">Log in</router-link></p>
        <p v-else class="text-login">Don't have an account? <router-link to="signup">Sign up</router-link></p>
    </div>
</template>
<script>
export default {
    name: 'FooterInfo',
    props: {
        isSignup: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
        };
    },
}
</script>